// 토스페이먼츠 카드사 코드 → 이름 (2026-09-22). 서버 사본 supabase/functions/_shared/cardCompany.ts 와 같은 표.
// 서버가 코드로 저장해 둔 옛 값(「31 7123」)도 화면에서는 이름으로 보이게 prettyMethodLabel 로 한 번 거른다.
export const CARD_COMPANY = Object.freeze({
  "3K": "기업BC카드", "46": "광주카드", "71": "롯데카드", "30": "KDB산업은행", "31": "BC카드", "51": "삼성카드", "38": "새마을금고",
  "41": "신한카드", "62": "신협", "36": "씨티카드", "33": "우리카드", "W1": "우리카드", "37": "우체국", "39": "저축은행", "35": "전북은행",
  "42": "제주은행", "15": "카카오뱅크", "3A": "케이뱅크", "24": "토스뱅크", "21": "하나카드", "61": "현대카드", "11": "KB국민카드",
  "91": "NH농협카드", "34": "수협은행",
});

export function cardCompanyName(code, fallback = "카드") {
  const c = String(code || "").trim();
  if (!c) return fallback;
  return CARD_COMPANY[c.toUpperCase()] || c;
}

/**
 * 저장된 결제수단 문구를 사람이 읽는 꼴로.
 *   "31 7123" → "BC카드 ···· 7123" · "신한카드 1234" → "신한카드 ···· 1234" · "면제" → 그대로
 * 🔒 서버 SQL email_method_label(20260923140000) 과 같은 규칙 — 메일과 화면이 같은 문구여야 한다.
 */
export function prettyMethodLabel(label) {
  if (!label) return label;
  let s = String(label);
  const m = s.match(/^([0-9A-Za-z]{2})(\s+.*)?$/);
  if (m) {
    const name = CARD_COMPANY[m[1].toUpperCase()];
    if (name) s = `${name}${m[2] || ""}`;
  }
  return s.replace(/^(.+) (\d{4})$/, "$1 ···· $2");
}
